import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-background-50">
                黑料bu打烊
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed">
              全网最全明星艺人黑料聚合平台，7×24小时不间断更新娱乐圈黑料、瓜事爆料、劲爆内幕。独家资讯一网打尽，随时随地吃瓜不断。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link
                to="/"
                className="text-sm text-background-300 hover:text-background-50 transition-colors"
              >
                首页
              </Link>
              <Link
                to="/category/zuixin-baoliao"
                className="text-sm text-background-300 hover:text-background-50 transition-colors"
              >
                最新爆料
              </Link>
              <Link
                to="/category/mingxing-heiliao"
                className="text-sm text-background-300 hover:text-background-50 transition-colors"
              >
                明星黑料
              </Link>
              <Link
                to="/category/lianqing-gua"
                className="text-sm text-background-300 hover:text-background-50 transition-colors"
              >
                恋情瓜
              </Link>
              <Link
                to="/about"
                className="text-sm text-background-300 hover:text-background-50 transition-colors"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">
              联系方式
            </h4>
            <div className="flex flex-col gap-2 text-sm text-background-300">
              <p>邮箱：contact@whxinantec.cn</p>
              <p>爆料投稿：tips@whxinantec.cn</p>
              <p>商务合作：biz@whxinantec.cn</p>
              <div className="flex items-center gap-4 mt-2">
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors"
                  aria-label="微博"
                >
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors"
                  aria-label="微信"
                >
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-600 transition-colors"
                  aria-label="抖音"
                >
                  <i className="ri-tiktok-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto mt-10 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-400">
              &copy; 2026 黑料bu打烊 版权所有 | 本站内容仅供娱乐参考，不构成任何投资或法律建议
            </p>
            <div className="flex items-center gap-4 text-xs text-background-400">
              <a href="#" className="hover:text-background-200 transition-colors">
                隐私政策
              </a>
              <a href="#" className="hover:text-background-200 transition-colors">
                用户协议
              </a>
              <a href="#" className="hover:text-background-200 transition-colors">
                免责声明
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}